import Vue from 'vue'

import store from './config/store'
import router from './config/router'
import { sync } from 'vuex-router-sync'

import Root from './components/Root'
import registerFilters from './config/registerFilters'
import registerComponents from './config/registerComponents'
import VueMask from 'v-mask'
import VueFullpage from 'vue-fullpage'
import VueScrollTo from 'vue-scrollto'
import VueProgressiveImage from 'vue-progressive-image'
import Viewer from 'v-viewer'

Vue.use(Viewer)
Vue.use(VueProgressiveImage)
Vue.use(VueScrollTo)
Vue.use(VueFullpage)
Vue.use(VueMask)
registerComponents(Vue)
registerFilters(Vue)

sync(store, router)

const app = new Vue({
  router,
  store,
  ...Root
})

export {app, router, store}



// WEBPACK FOOTER //
// ./src/app/index.js